module.exports = __webpack_public_path__ + "img/logo_cost_main.884a1778.png";